// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WV2R","right":"styles_right__2Q4ns"};